<template>
  <div>
    <!-- Your chat textboxes -->
    <div class="chat-textbox" v-for="(textbox, index) in chatTextboxes" :key="index">
      <!--<input type="text" v-model="textbox.value" @input="handleInput">-->
      <div class="editable-div" contenteditable="true" @input="handleInputChange">typing..</div>
    </div>

    <!-- Options Popup -->
    <optionspopup :options="filteredOptions"
                   :showOptions="showOptions && filteredOptions.length > 0"
                   :position="popupPosition" ></optionspopup>
  </div>
</template>

<script>
  import OptionsPopup from './OptionsPopup.vue'; // Adjust path as per your file structure

  export default {
    name: "chatcomponent",
    components: {
      OptionsPopup
    },
    data() {
      return {
        chatTextboxes: [
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          { value: '' },
          // Add more as needed
        ],
        options: [            // Example options (tags)
          { id: 1, name: 'tag1' },
          { id: 2, name: 'tag2' },
          { id: 3, name: 'tag3' },
        ],
        filteredOptions: [],  // To store filtered options based on input
        activeTextboxIndex: -1,  // Track which textbox's options are active
        popupPosition: { x: 0, y: 0 },  // Position of the popup
        showOptions: false,
        cursorPosition: 0,
        textarea: null,
      };
    },
    methods: {
      async loadUsers() {
        try {
          this.$http.get('/api/Users/v1').then(async response => {
            this.users = [];

            if (response.data !== null && response.data.length > 0) {
              response.data = response.data.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            this.options = [];
            for (var i = 0; i < response.data.length; i++) {
              //if (i < 5) {
              this.options.push({
                id: response.data[i].UserName, name: response.data[i].Name
              });
              //}
            }
            //this.filterUsers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      handleInputChange(event) {
        this.showOptionsPopup(event);
        this.textarea = event.target;
        //console.log('Content changed:', event.target.innerText);
        this.handleInput(event.target.innerText);
        // Additional actions based on the input change
      },
      handleInput(text) {
        // Get the selection range
        const selection = window.getSelection();
        var selectionStart = 0;

        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          // Now you can access selection start and end positions
          selectionStart = range.startOffset;
          const selectionEnd = range.endOffset;
          //console.log('Selection start:', selectionStart);
          //console.log('Selection end:', selectionEnd);
        }

        //var m = $('#messageinput' + this.threadid).val();
        this.content = text;
        //alert(this.content);
        //const textarea = this.$el.querySelector('.emojionearea-editor');//this.$refs.textarea;
        const cursorPosition = selectionStart;//textarea.selectionStart;

        const contentBeforeCursor = this.content.substring(0, cursorPosition);

        // Check if "@" is typed and show options accordingly
        const lastWord = contentBeforeCursor.split(/\s+/).pop();
        if (lastWord && lastWord.charAt(0) === '@') {
          const query = lastWord.substring(1).toLowerCase(); // Get the query after "@"
          this.filteredOptions = this.options.filter(option =>
            option.name.toLowerCase().includes(query)
          );
          this.showOptions = true;
          // Attach click event listener to close popup when clicking outside
          document.addEventListener('click', this.onClickOutside);
          this.cursorPosition = cursorPosition; // Save cursor position for insertion
        } else {
          this.showOptions = false;
          // Remove click event listener when popup is hidden
          document.removeEventListener('click', this.onClickOutside);
        }
      },
      selectOption(index) {
        // Replace text after "@" with selected option
        const selectedOption = this.filteredOptions[index];
        const optionName = selectedOption.name + ' ';
        let start = this.cursorPosition - (this.content.split(/\s+/).pop().length)+ 1;
        const end = this.cursorPosition;

        if (start !== end) {
          start = start - 1;
        }

        const newText = this.content.substring(0, start) + optionName + this.content.substring(end);

        this.content = newText;
        this.showOptions = false;
        const textarea = this.textarea;//this.$el.querySelector('.emojionearea-editor');
        //textarea.innerHTML = this.content;
        $(textarea).html(newText);
        console.log('div content:' + $(textarea).html())
        this.$nextTick(() => {
          // Set cursor position after inserted option
          const newCursorPosition = start + optionName.length;
          textarea.selectionStart = newCursorPosition;
          textarea.selectionEnd = newCursorPosition;
        });
        //this.$forceUpdate();
      },
      showOptionsPopup(event) {
        // Calculate position based on event coordinates or any other logic
        //this.popupPosition = {
        //  x: event.clientX,  // Example: X position based on mouse click event
        //  y: event.clientY   // Example: Y position based on mouse click event
        //};

        // Get the position of the div relative to the viewport
        const rect = event.target.getBoundingClientRect();

        // Log or use the position data as needed
        console.log('Div position:', rect.left, rect.top);
        this.popupPosition = {
          x: rect.left,  // Example: X position based on mouse click event
          y: rect.top-150,   // Example: Y position based on mouse click event
        };
        console.log(this.popupPosition);
      },
      onClickOutside(event) {
        // Check if clicked element is outside the popup
        if (this.showOptions && this.filteredOptions.length > 0) {
          this.showOptions = false;
          // Remove event listener after closing popup
          document.removeEventListener('click', this.onClickOutside);
        }
      }
    },
    mounted() {
      this.loadUsers();
    }
  };
</script>

<style>
  .chat-textbox {
    margin-bottom: 10px;
    position: relative; /* Ensure relative positioning for absolute children */
  }

  .editable-div {
    width: 300px;
    height: 50px;
    border: 1px solid #ccc;
    padding: 10px;
    overflow-y: auto; /* Enable vertical scrolling if content exceeds height */
    white-space: pre-wrap; /* Preserve line breaks and spaces */
    outline: none; /* Remove default focus outline */
    cursor: text; /* Show text cursor on hover */
    font-family: Arial, sans-serif; /* Set font style */
    font-size: 14px; /* Set font size */
    line-height: 1.5; /* Set line height */
  }
</style>



// WEBPACK FOOTER //
// src/components/discuss/prac/ChatComponent.vue